import React from 'react'
import './WhyLoveUs.scss'

function WhyLoveUs() {
  const benefits: string[] = [
    'Apply 10× faster with personalized materials',
    'Get insights into every company before your interview',
    'Stand out with applications tailored to the role',
    'All your job materials in one dashboard'
  ]

  return (
    <section className="py-5 why-love-us-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <h2 
              className="text-center mb-5 fw-bold"
              style={{
                fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif",
                fontSize: '36px',
                lineHeight: '44px',
                letterSpacing: '-0.02em',
                color: '#181a25'
              }}
            >
              Why Job Seekers Love JobsReadyAI
            </h2>
            
            <div className="row g-4 mb-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="col-md-6">
                  <div className="d-flex align-items-start gap-3">
                    <div 
                      className="d-flex align-items-center justify-content-center flex-shrink-0"
                      style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: '#505fe2',
                        color: '#ffffff',
                        fontSize: '20px',
                        fontWeight: 'bold',
                        borderRadius: '50%',
                        flexShrink: 0
                      }}
                    >
                      ✓
                    </div>
                    <p 
                      className="mb-0"
                      style={{
                        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif",
                        fontSize: '18px',
                        lineHeight: '28px',
                        color: '#181a25'
                      }}
                    >
                      {benefit}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WhyLoveUs
